import { PasswordRecovery } from './passwordRecovery'

export { PasswordRecovery }
